export const ActionTypes = {
  SET_PRIVACY_POLICY_URL:'SET_PRIVACY_POLICY_URL',
  SET_PRIVACY_POLICY_CONTENT:'SET_PRIVACY_POLICY_CONTENT'
};
